import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {DisposeInfo} from "./subPages/DisposeInfo";
import {CommonHistoryList} from "../../settings/history/subPages/CommonHistoryList";
import {useDispatch, useSelector} from "react-redux";
import {skeleton} from "../../../redux/slice/apiSlice";
import {getDispose, removeDisposes} from "../../../api/lifecycle/dispose/DisposeService";
import {ContentCategory} from "../../../constant/CodeSpecNum";
import {getContentStatus} from "../../../api/contentStatus/contentStatusService";
import {changeProgressStatusValue, changeStatusNumericValue} from "../../../redux/slice/contentSlice";
import {handleActiveError} from "../../../components/sonner/ToastBasic";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";

const DEFAULT_TABS = [
    {clicked: true, name: "기본정보"},
    {clicked: false, name: "이력관리"},
];

function DisposeTab() {
    const {id} = useParams();
    const status = useSelector((state) => state.api.status);
    const statusNumericValue = useSelector((state) => state.content.statusNumericValue);
    const refresh = useSelector((state) => state.status.refreshContent);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [tabs, setTabs] = useState(DEFAULT_TABS);
    const [dispose, setDispose] = useState({});
    const [assets, setAssets] = useState([]);

    useEffect(() => {
        setDispose({});
        setAssets([]);
        setTabs(DEFAULT_TABS);
        dispatch(changeStatusNumericValue(0));
        dispatch(changeProgressStatusValue({}));
    }, [id, dispatch]);

    useEffect(() => {
        if (!id) return;

        let cancelled = false;
        dispatch(skeleton(true));

        Promise.all([
            getDispose(id),
            getContentStatus({contentId: id, contentCategory: ContentCategory.DISPOSE}),
        ])
            .then(([disposeResponse, statusNumericValueResponse]) => {
                if (cancelled) return;

                if (disposeResponse.status === 201) {
                    if (disposeResponse.data.errorCode === "AUTHORITY") {
                        alert(disposeResponse.data.reason);
                        navigate(-1);
                    }
                }

                if (disposeResponse?.data) {
                    setDispose(disposeResponse.data);
                    setAssets(disposeResponse.data.assets?.map((item) => item.asset) ?? []);
                }

                if (statusNumericValueResponse?.status === 200) {
                    dispatch(changeStatusNumericValue(statusNumericValueResponse.data.statusNumericValue));
                    dispatch(changeProgressStatusValue(statusNumericValueResponse.data));
                }
            })
            .finally(() => {
                if (!cancelled) {
                    dispatch(skeleton(false));
                }
            });

        return () => {
            cancelled = true;
        };
    }, [id, status, refresh, dispatch, navigate]);

    if (Object.keys(dispose).length > 0) {
        return (
            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
                <DetailHeroSummaryProvider>
                    <DetailTabBar tabs={tabs} setTabs={setTabs} />
                    {tabs[0].clicked && (
                        <DisposeInfo
                            id={id}
                            dispose={dispose}
                            assets={assets}
                            statusNumericValue={statusNumericValue}
                        />
                    )}
                    {tabs[1].clicked && <CommonHistoryList id={id} tableName="자산폐기관리" />}
                </DetailHeroSummaryProvider>
            </div>
        );
    }

    return null;
}

export {DisposeTab};
